export default function basicTableSort(
  data: any[],
  fieldName: string,
  sortOrder: number,
) {
  const clone = [...data];
  return clone?.sort((a, b) =>
    // eslint-disable-next-line no-nested-ternary
    a[fieldName]?.toString().toLowerCase() ===
    b[fieldName]?.toString().toLowerCase()
      ? 0
      : a[fieldName]?.toString().toLowerCase() >
        b[fieldName]?.toString().toLowerCase()
      ? sortOrder
      : -sortOrder,
  );
}
